import type { FieldErrors, FieldValues, UseFormSetValue } from 'react-hook-form';

export class FormularioUtil {
  static atribuirFocusErro = (erros: FieldErrors<FieldValues>) => {
    const primeroErro = Object.keys(erros).reduce((prev: string, curr: string) => {
      return erros[prev] ? prev : curr;
    }, '');

    const elemento = window.document.getElementsByName(primeroErro).item(0);

    if (elemento) {
      elemento.scrollIntoView({ behavior: 'smooth', block: 'center' });

      elemento.focus();
    }
  };

  static atribuirMultiplosValores = (
    values: Record<string, any>,
    setValue: UseFormSetValue<FieldValues>,
  ) => {
    Object.entries(values).forEach(([key, value]) => setValue(key, value));
  };
}
